import React from 'react'
import './stylesL.css'

export default function Loading({ text, color = 'black', styleText = {} }) {
  return (
    <div className='contain-load'>
      <div className='load-spinner' />
      {text && (
        <label className={color === 'black' ? 'load-text' : 'load-text-white'} style={styleText}>
          {text.split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </label>
      )}
    </div>
  )
}
